import {createApiResource} from 'data/utils';

export const resource = createApiResource({
	name: 'listItem',
	pathName: '/listItems',
	// `utils/api` returns parsed JSON directly (not `{data: ...}`), so we must not default-unwrap.
	unwrap: x => x,
});
